module.exports = __webpack_public_path__ + "img/DSC_7328.09ada1b2.jpg";